import React, { memo, useMemo } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import { OSOReportList, SSReportList } from "./reports";
import useStableCallback from "../../hooks/useStableCallback";

const ReportsContainerSx = { padding: 1, marginTop: 1 };

const ReportsTitleSx = { marginLeft: "13px", marginTop: "0px" };

const ReportsBodySx = { marginLeft: "13px", marginTop: "0px" };

const ReportsLaunchIconSx = { marginLeft: "3px", fontSize: "15px" };

const ReportsListItemSx = {
  ".report-link": {
    display: "flex",
    cursor: "pointer",
    alignItems: "center",
    fontWeight: 500,
    ".report-label": {
      "&:hover": {
        textDecoration: "underline",
        textShadow: "0 0 0.5px #c60c30",
      },
    },
    ":hover": {
      color: (theme) => theme.palette.primary.main,
      ".report-label": {
        textDecoration: "underline",
        textShadow: "0 0 0.5px #c60c30",
      },
    },
  },
};

const GetOSOReportList = (handleReportLinkClick) => {
  const list = [];
  for (let i = 0; i < OSOReportList.length; i++) {
    const report = OSOReportList[i];
    list.push(
      <ListItem key={report.label} sx={ReportsListItemSx}>
        <div className="report-link" onClick={handleReportLinkClick(report)}>
          {i + 1}.&nbsp;
          <span className="report-label">{report.label} </span>
          <LaunchOutlinedIcon size="small" sx={ReportsLaunchIconSx} />
        </div>
      </ListItem>
    );
  }
  return list;
};

const GetSSReportList = (handleReportLinkClick) => {
  const list = [];
  for (let i = 0; i < SSReportList.length; i++) {
    const report = SSReportList[i];
    list.push(
      <ListItem key={report.label} sx={ReportsListItemSx}>
        <div className="report-link" onClick={handleReportLinkClick(report)}>
          {i + 1}.&nbsp;
          <span className="report-label">{report.label} </span>
          <LaunchOutlinedIcon size="small" sx={ReportsLaunchIconSx} />
        </div>
      </ListItem>
    );
  }
  return list;
};

const Report = () => {
  const handleReportLinkClick = useStableCallback((report) => () => {
    if (report.url) {
      window.open(report.url, "_blank");
    }
  });

  const OSOReportListRenderer = useMemo(() => {
    return GetOSOReportList(handleReportLinkClick);
  }, [handleReportLinkClick]);

  const SSReportListRenderer = useMemo(() => {
    return GetSSReportList(handleReportLinkClick);
  }, [handleReportLinkClick]);

  return (
    <Container id="page-container" maxWidth="xl" sx={{ paddingY: 2 }}>
      <Paper id="acc-container" sx={ReportsContainerSx}>
        <Typography variant="h6" sx={ReportsTitleSx}>
          Reports
        </Typography>
        <Typography variant="body1" gutterBottom sx={ReportsBodySx}>
          Please click to any report link below to open the reporting tool to
          the new tab.
        </Typography>
        <Divider variant="middle" />
        <Typography variant="h6" sx={{ ...ReportsTitleSx, mt: 1 }}>
          OSO Reports
        </Typography>
        <List aria-label="oso-report-list">{OSOReportListRenderer}</List>
        <Divider variant="middle" />
        <Typography variant="h6" sx={{ ...ReportsTitleSx, mt: 1 }}>
          Store Supplies Reports
        </Typography>
        <List aria-label="ss-report-list">{SSReportListRenderer}</List>
      </Paper>
    </Container>
  );
};

export default memo(Report);
